'use client';
import { jsx } from 'react/jsx-runtime';
import { TableHeadContext } from './table.context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(e, r) {
    if (null == e) return {};
    var t, o, n = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(o = 0; o < i.length; o++)t = i[o], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
    }
    return n;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var t, o, n = {}, i = Object.keys(e);
    for(o = 0; o < i.length; o++)t = i[o], r.indexOf(t) >= 0 || (n[t] = e[t]);
    return n;
}
const TableHead = renderWithRef('TableHead', null, (t, n)=>{
    var { children: i } = t, l = _object_without_properties(t, [
        "children"
    ]);
    return jsx(TableHeadContext.Provider, {
        value: true,
        children: jsx(RenderComp, {
            root: "thead",
            classNames: [
                'swan-thead'
            ],
            forwardedRef: n,
            props: l,
            children: i
        })
    });
});

export { TableHead };
